import { alpha } from '@mui/material';
import { teal as finsightTeal } from '@mui/material/colors';

export const getMinimalVariantStyles = () => ({
  '.MuiInputBase-root::before': {
    border: 'none',
  },
});

export const getPopperStyles = () => ({
  '&::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: alpha(finsightTeal[800], 0.1),
    borderRadius: '0.5em',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: alpha(finsightTeal[700], 0.5),
    borderRadius: '0.5em',
  },
  '& .MuiAutocomplete-listbox': {
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: alpha(finsightTeal[800], 0.1),
      borderRadius: '0.5em',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(finsightTeal[700], 0.5),
      borderRadius: '0.5em',
    },
  },
});
